import { routeName } from "../utils";
import pageConfig from "@/config/page";
const page = pageConfig.pages.member;

const name = "member";

export default {
  name: name,
  path: name,
  component: () => import("@/layout/routerView"),
  redirect: { name: routeName("board", name) },
  meta: {
    disable: true,
  },
  children: [
    {
      name: routeName("board", name),
      path: "board",
      redirect: { name: routeName("board.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("board.index", name),
          path: "",
          component: page.board,
          props: { hasUser: false },
        },
        {
          name: routeName("board.user", name),
          path: ":username",
          component: page.board,
          props: { hasUser: true },
        },
      ],
    },
    {
      name: routeName("profile", name),
      path: "profile",
      component: page.profile,
    },
    {
      name: routeName("sub", name),
      path: "sub",
      component: page.sub,
    },
    {
      name: routeName("admin", name),
      path: "admin",
      component: page.admin,
    },
    {
      name: routeName('distributed', name),
      path: 'distributed',
      redirect: { name: routeName("distributed.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName('distributed.index', name),
          path: '',
          component: page.distributed,
        },
        {
          name: routeName('distributed.user', name),
          path: ':username',
          component: page.distributed,
          props: true
        }
      ]
    }
  ],
};
